var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaded
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "spareparts_basket px-4 py-5",
            class: [
              _vm.theme == "dark" ? "bg-third-dark" : "bg-fifth-white",
              "spareparts_basket--" + _vm.theme,
              "text-primary-" + _vm.theme,
            ],
          },
          [
            _c("h2", { staticClass: "pb-5" }, [
              _vm._v(
                _vm._s(_vm.t("general.basket")) +
                  " (" +
                  _vm._s(_vm.articlesLoaded.length) +
                  " " +
                  _vm._s(_vm.t("checkout.article")) +
                  ")"
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "spareparts_basket__articles" },
              _vm._l(_vm.articlesLoaded, function (article) {
                return _c(
                  "div",
                  {
                    staticClass:
                      "row mx-0 spareparts_basket__articles__item pt-3 pb-5",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-auto col-lg-4 px-0 px-sm-3 px-lg-0 py-xl-1 spareparts_basket__articles__item__img",
                      },
                      [
                        article.productData.color.fabricId != null &&
                        article.productData.color.fabricId != "" &&
                        article.productData.medias[0].path !=
                          "//suncomfort.glatz.com/media/glatz_thumbnail.png"
                          ? [
                              article.productData.medias[0].path
                                ? _c("div", {
                                    staticClass:
                                      "spareparts_basket__articles__item__img--fabric",
                                    class: "bg-specialbackground-" + _vm.theme,
                                    style: {
                                      backgroundImage:
                                        "url(" +
                                        article.productData.medias[0].path +
                                        ")",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          : [
                              article.productData.medias[0].path
                                ? _c("div", {
                                    class: "bg-specialbackground-" + _vm.theme,
                                    style: {
                                      backgroundImage:
                                        "url(" +
                                        article.productData.medias[0].path +
                                        ")",
                                    },
                                  })
                                : _vm._e(),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pl-3 pr-0 pr-sm-3 pr-lg-0 spareparts_basket__articles__item__details",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _c("h3", { staticClass: "pr-2" }, [
                              _vm._v(_vm._s(article.productData.title)),
                            ]),
                            _vm._v(" "),
                            _c("h4", {}, [
                              _vm._v(
                                _vm._s(article.productData.priceFormatted)
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "pt-3" }, [
                          _vm._v(
                            _vm._s(_vm.t("general.count")) +
                              " " +
                              _vm._s(article.productQty)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "spareparts_basket__articles__item__details__delete",
                            on: {
                              click: function ($event) {
                                return _vm.removeProduct(
                                  article.id,
                                  article.productQty
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.t("checkout.remove")))]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex pt-5 justify-content-between" }, [
              _c("p", [_vm._v(_vm._s(_vm.t("general.deliverycost")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.deliverPrice))]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex pt-1 pb-2 justify-content-between" },
              [
                _c("p", [_vm._v(_vm._s(_vm.t("general.wholeprice")))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.wholePrice))]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }